import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeClientStrip({ serviceCards }) {
  const navigate = useNavigate();

  const handleClick = (filterName) => (e) => {
    e.preventDefault();
    navigate(`/service-listing?filterBy=${encodeURIComponent(filterName)}`);
  };

  return (
    <section className="client-strip" aria-label="DALMAF business focus">
      {serviceCards && serviceCards.length > 0 ? (
        serviceCards.map((data, index) => (
          <span
            key={index}
            className="cs-item"
            style={{ cursor: 'pointer' }}
            onClick={handleClick(data.filter || data.title)}
          >
            <em>{data?.count}</em>
            {data?.title}
          </span>
        ))
      ) : (
        <>
          <span className="cs-item" style={{ cursor: 'pointer' }} onClick={handleClick('Audit')}>
            <em>01</em>Audit &amp; Assurance
          </span>
          <span className="cs-item" style={{ cursor: 'pointer' }} onClick={handleClick('Legal')}>
            <em>02</em>Legal Consultation
          </span>
          <span className="cs-item" style={{ cursor: 'pointer' }} onClick={handleClick('HR ')}>
            <em>03</em>HR Services
          </span>
          <span className="cs-item">
            <em>04</em>GST, TDS and ITR Filing
          </span>
          <span className="cs-item">
            <em>05</em>Regulatory Advisory
          </span>
        </>
      )}
    </section>
  );
}
